// src/layouts/CheckLayout.jsx
// Mevcut AppShell düzeniniz korunmuştur. CompanyList bu Outlet içine render edilir.
import { AppShell, Container, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Outlet } from 'react-router-dom';
import CheckSidebar from '../components/CheckSidebar';
import TopNavbar from '../components/TopNavbar';

export default function CheckLayout() {
  const [opened, { toggle, close }] = useDisclosure();

  return (
    <AppShell
      header={{ height: 65 }}
      navbar={{ width: 240, breakpoint: 'sm', collapsed: { mobile: !opened } }}
      padding="md"
      bg="gray.0"
    >
      <AppShell.Header className="no-print">
        <TopNavbar opened={opened} toggle={toggle} showBackButton={true} title="SMS Grup" highlight="Finans & Çek" />
      </AppShell.Header>
      <AppShell.Navbar p="md" className="no-print">
        <Text c="dimmed" size="xs" fw={700} mb="sm" tt="uppercase" ls={1}>
          Çek İşlemleri
        </Text>
        <CheckSidebar onClose={close} />
      </AppShell.Navbar>
      <AppShell.Main>
        <Container fluid px={0}>
          <Outlet />
        </Container>
      </AppShell.Main>
    </AppShell>
  );
}
